// @flow
import { createSelector } from 'reselect'

// Libs
import _map from 'lodash/map'

// Selectors
import { fieldOfJob } from 'hfty-assets'
import currentUserUnits$ from 'hfty-users/src/selectors/currentUserUnits'
import { gridOffset$ } from 'hfty-map'

// Constants
import {
  GRID_UNIT_HECTARES,
  GRID_UNIT_ACRES,
} from 'hfty-model-grid'

import { PROP_US_CUSTOMARY } from 'fc-model-users/src/constants'

export default (jobId: number): Function => {
  const fieldOfJob$ = fieldOfJob(jobId)
  return createSelector(
    [
      fieldOfJob$,
      currentUserUnits$,
      gridOffset$,
    ],
    (field: ?Object, units: string, gridOffset: Object): Array<Object> => {
      if (!field || !field.shape) { return null }
      const features = field.shape.shapeData.features
      const newFeatures = _map(features, (feature: Object, featureIndex: number): Object => {
        return {
          ...feature,
          properties: {
            ...feature.properties,
            size: 5,
            offset: gridOffset,
            rotation: 0,
            units: units === PROP_US_CUSTOMARY ? GRID_UNIT_ACRES : GRID_UNIT_HECTARES,
            featureIndex,
          },
        }
      })
      return {
        ...field.shape.shapeData,
        features: newFeatures,
      }
    }
  )
}
